import { render, staticRenderFns } from "./limitReserve.vue?vue&type=template&id=6ce181a4&scoped=true&"
import script from "./limitReserve.vue?vue&type=script&lang=js&"
export * from "./limitReserve.vue?vue&type=script&lang=js&"
import style0 from "./limitReserve.vue?vue&type=style&index=0&id=6ce181a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce181a4",
  null
  
)

export default component.exports